// @flow
import type {SagaIterator} from 'redux-saga';
import {FULFILLED} from 'redux-promise-middleware';

import {takeLatest, select, call} from 'redux-saga/effects';
import {
    sendPrescription,
    createZendeskTicket,
} from 'features/uploadRx/reducers/createdOrder/createdOrder';
import {getCreatedOrder} from 'features/uploadRx/selectors/createdOrder/createdOrder';
import type {CreatedOrderItemType} from 'features/uploadRx/reducers/createdOrder/createdOrderType';

/**
 * Creates zendesk ticket when customer uploaded all prescriptions for each item
 */
export function* createTicket(): SagaIterator {
    const createdOrder = yield select(getCreatedOrder);
    if (createdOrder.items.every((item: CreatedOrderItemType) => item.status === FULFILLED)) {
        yield call(createZendeskTicket, createdOrder.orderId);
    }
}

/**
 * Makes scroll
 */
export function scrollTop() {
    if (document.body) {
        document.body.scrollTop = 0; // For Safari
    }
    if (document.documentElement) {
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
}

/**
 * Scroll top listener
 */
export function* scrollToTop(): SagaIterator {
    const createdOrder = yield select(getCreatedOrder);
    if (createdOrder.items.every((item: CreatedOrderItemType) => item.status === FULFILLED)) {
        yield call(scrollTop);
    }
}

/**
 * Root send prescription saga on upload prescription page
 */
export function* sendPrescriptionSaga(): SagaIterator {
    yield takeLatest(`${sendPrescription}_${FULFILLED}`, createTicket);
    yield takeLatest(`${sendPrescription}_${FULFILLED}`, scrollToTop);
}
